var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dinein)?_c(_vm.dinein,{tag:"component",on:{"open-drawer":function($event){return _vm.$emit('open-drawer')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }